/**
 * 组件的emit事件声明
 */
export const emits = [
  /** 展开状态变化（Vue3 v-model） */
  'update:modelValue',
  /** 展开状态变化（Vue2 v-model） */
  'input',
  /** 点击操作按钮（危险操作为确认后触发） */
  'action',
  /** 操作区展开 */
  'open',
  /** 操作区收起 */
  'close',
  /** 点击内容区 / 操作区 */
  'click',
];
